/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component } from '@angular/core';

@Component({
    selector: 'app-lun-snap-shot-detail',
    templateUrl: './lun-snap-shot-detail.component.html',
})
export class LunSnapShotDetailComponent {
    data;
}
